import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "eat-set-content"
};
const _hoisted_2 = {
  class: "eat-set-content-item"
};
const _hoisted_3 = {
  class: "sub-title"
};
const _hoisted_4 = {
  class: "search-box"
};
const _hoisted_5 = {
  class: "item-list"
};
const _hoisted_6 = {
  class: "block"
};
const _hoisted_7 = {
  class: "batch-btn"
};
const _hoisted_8 = {
  class: "eat-set-content-item"
};
const _hoisted_9 = {
  class: "sub-title"
};
const _hoisted_10 = {
  key: 0
};
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = {
  class: "search-box"
};
const _hoisted_14 = {
  class: "item-list"
};
const _hoisted_15 = {
  class: "block"
};
const _hoisted_16 = {
  class: "batch-btn"
};
const _hoisted_17 = {
  class: "eat-set-content-item"
};
const _hoisted_18 = {
  class: "sub-title"
};
const _hoisted_19 = {
  class: "search-box"
};
const _hoisted_20 = {
  class: "item-list"
};
const _hoisted_21 = {
  class: "block"
};
const _hoisted_22 = {
  class: "batch-btn"
};
const _hoisted_23 = {
  class: "eat-set-content-item"
};
const _hoisted_24 = {
  class: "sub-title"
};
const _hoisted_25 = {
  key: 0
};
const _hoisted_26 = {
  key: 1
};
const _hoisted_27 = {
  key: 2
};
const _hoisted_28 = {
  class: "search-box"
};
const _hoisted_29 = {
  class: "item-list"
};
const _hoisted_30 = {
  class: "block"
};
const _hoisted_31 = {
  class: "batch-btn"
};
import { getItemOrIngredApi, removeItemOrIngred, updateItemOrIngredApi, getItemListPage, getIngredListPage } from "@/service/modules/scan";
import { ElMessage } from "element-plus";
import { ref, watch, reactive } from "vue";
export default /*@__PURE__*/_defineComponent({
  __name: 'eat-set',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    diseaseId: {
      type: Number,
      default: 1
    },
    eatType: {
      type: Number,
      default: 1
    }
  },
  emits: ["closeDialog"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    // 物品列表相关数据
    const itemList = ref([]);
    const itemSearchKey = ref("");
    const selectedItemList = ref([]);
    const selectedItemSearchKey = ref("");
    // 成分列表相关数据
    const ingredList = ref([]);
    const ingredSearchKey = ref("");
    const selectedIngredList = ref([]);
    const selectedIngredSearchKey = ref("");
    // 多选相关数据
    const selectedItems = ref([]);
    const selectedSelectedItems = ref([]);
    const selectedIngreds = ref([]);
    const selectedSelectedIngreds = ref([]);
    // 物品列表分页
    const itemPage = reactive({
      current: 1,
      size: 20,
      total: 0
    });
    // 获取物品列表
    async function getItemList(val) {
      console.log(val);
      if (val) {
        itemPage.current = val;
      }
      try {
        let res = await getItemListPage({
          ...itemPage,
          name: itemSearchKey.value
        });
        // const res = await getAllItemList(itemSearchKey.value);
        console.log(123, res);
        if (res) {
          itemList.value = res.data.records || [];
          itemPage.total = Number(res.data.total);
        }
      } catch (error) {
        console.error("获取物品列表失败", error);
      }
    }
    // 物品已选择物品列表分页
    const selectedItemPage = reactive({
      current: 1,
      size: 20,
      total: 0
    });
    // 获取已选择物品列表
    async function getSelectedItemList(val) {
      if (val) {
        selectedItemPage.current = val;
      }
      try {
        const res = await getItemOrIngredApi({
          diseaseId: props.diseaseId,
          type: 1,
          // 物品类型
          name: selectedItemSearchKey.value,
          edible: props.eatType === 2 ? false : true,
          moderation: props.eatType === 3 ? true : false,
          size: selectedItemPage.size,
          current: selectedItemPage.current
        });
        if (res) {
          selectedItemList.value = res.data.records || [];
          selectedItemPage.total = Number(res.data.total);
        }
      } catch (error) {
        console.error("获取已选择物品列表失败", error);
      }
    }
    // 成分列表分页
    const ingredPage = reactive({
      current: 1,
      size: 20,
      total: 0
    });
    // 获取成分列表
    async function getIngredList(val) {
      if (val) {
        ingredPage.current = val;
      }
      try {
        let res = await getIngredListPage({
          ...ingredPage,
          name: ingredSearchKey.value
        });
        // const res = await getAllIngredList(ingredSearchKey.value);
        if (res) {
          ingredList.value = res.data.records || [];
          ingredPage.total = Number(res.data.total);
        }
      } catch (error) {
        console.error("获取成分列表失败", error);
      }
    }
    // 成分已选择列表分页
    const selectedIngredPage = reactive({
      current: 1,
      size: 20,
      total: 0
    });
    // 获取已选择成分列表
    async function getSelectedIngredList(val) {
      if (val) {
        selectedIngredPage.current = val;
      }
      try {
        const res = await getItemOrIngredApi({
          diseaseId: props.diseaseId,
          type: 2,
          // 成分类型
          name: selectedIngredSearchKey.value,
          edible: props.eatType === 2 ? false : true,
          moderation: props.eatType === 3 ? true : false,
          size: selectedIngredPage.size,
          current: selectedIngredPage.current
        });
        if (res) {
          selectedIngredList.value = res.data.records || [];
          selectedIngredPage.total = Number(res.data.total);
        }
      } catch (error) {
        console.error("获取已选择成分列表失败", error);
      }
    }
    // 搜索物品
    function searchItems() {
      getItemList();
    }
    // 搜索已选择物品
    function searchSelectedItems() {
      getSelectedItemList();
    }
    // 搜索成分
    function searchIngreds() {
      getIngredList();
    }
    // 搜索已选择成分
    function searchSelectedIngreds() {
      getSelectedIngredList();
    }
    // 添加物品
    async function addItem(item) {
      try {
        const res = await updateItemOrIngredApi({
          diseaseId: props.diseaseId,
          ids: [item.id],
          edible: props.eatType === 2 ? false : true,
          moderation: props.eatType === 3 ? true : false,
          updateType: 1
        });
        if (res) {
          ElMessage.success("添加成功");
          getItemList();
          getSelectedItemList();
        }
      } catch (error) {
        console.error("添加物品失败", error);
        ElMessage.error("添加失败");
      }
    }
    // 移除物品
    async function removeItem(item) {
      try {
        const res = await removeItemOrIngred({
          diseaseId: props.diseaseId,
          type: 1,
          // 物品类型
          itemIds: [item.id]
        });
        if (res) {
          ElMessage.success("移除成功");
          getItemList();
          getSelectedItemList();
        }
      } catch (error) {
        console.error("移除物品失败", error);
        ElMessage.error("移除失败");
      }
    }
    // 添加成分
    async function addIngred(ingred) {
      try {
        const res = await updateItemOrIngredApi({
          diseaseId: props.diseaseId,
          ids: [ingred.id],
          edible: props.eatType === 2 ? false : true,
          moderation: props.eatType === 3 ? true : false,
          updateType: 2
        });
        if (res) {
          ElMessage.success("添加成功");
          getIngredList();
          getSelectedIngredList();
        }
      } catch (error) {
        console.error("添加成分失败", error);
        ElMessage.error("添加失败");
      }
    }
    // 移除成分
    async function removeIngred(ingred) {
      try {
        const res = await removeItemOrIngred({
          diseaseId: props.diseaseId,
          type: 2,
          // 成分类型
          itemIds: [ingred.id]
        });
        if (res) {
          ElMessage.success("移除成功");
          getIngredList();
          getSelectedIngredList();
        }
      } catch (error) {
        console.error("移除成分失败", error);
        ElMessage.error("移除失败");
      }
    }
    // 批量添加物品
    async function batchAddItems() {
      if (selectedItems.value.length === 0) {
        ElMessage.warning("请选择要添加的物品");
        return;
      }
      try {
        const ids = selectedItems.value.map(item => item.id);
        const res = await updateItemOrIngredApi({
          diseaseId: props.diseaseId,
          updateType: 1,
          // 物品类型
          ids,
          edible: props.eatType === 2 ? false : true,
          moderation: props.eatType === 3 ? true : false
        });
        if (res) {
          ElMessage.success("批量添加成功");
          getItemList();
          getSelectedItemList();
        }
      } catch (error) {
        console.error("批量添加物品失败", error);
        ElMessage.error("批量添加失败");
      }
    }
    // 批量移除物品
    async function batchRemoveItems() {
      if (selectedSelectedItems.value.length === 0) {
        ElMessage.warning("请选择要移除的物品");
        return;
      }
      try {
        const ids = selectedSelectedItems.value.map(item => item.id);
        const res = await removeItemOrIngred({
          diseaseId: props.diseaseId,
          type: 1,
          // 物品类型
          itemIds: ids
        });
        if (res) {
          ElMessage.success("批量移除成功");
          getItemList();
          getSelectedItemList();
        }
      } catch (error) {
        console.error("批量移除物品失败", error);
        ElMessage.error("批量移除失败");
      }
    }
    // 批量添加成分
    async function batchAddIngreds() {
      if (selectedIngreds.value.length === 0) {
        ElMessage.warning("请选择要添加的成分");
        return;
      }
      try {
        const ids = selectedIngreds.value.map(ingred => ingred.id);
        const res = await updateItemOrIngredApi({
          diseaseId: props.diseaseId,
          ids,
          edible: props.eatType === 2 ? false : true,
          moderation: props.eatType === 3 ? true : false,
          updateType: 2
        });
        if (res) {
          ElMessage.success("批量添加成功");
          getIngredList();
          getSelectedIngredList();
        }
      } catch (error) {
        console.error("批量添加成分失败", error);
        ElMessage.error("批量添加失败");
      }
    }
    // 批量移除成分
    async function batchRemoveIngreds() {
      if (selectedSelectedIngreds.value.length === 0) {
        ElMessage.warning("请选择要移除的成分");
        return;
      }
      try {
        const ids = selectedSelectedIngreds.value.map(ingred => ingred.id);
        const res = await removeItemOrIngred({
          diseaseId: props.diseaseId,
          type: 2,
          // 成分类型
          itemIds: ids
        });
        if (res) {
          ElMessage.success("批量移除成功");
          getIngredList();
          getSelectedIngredList();
        }
      } catch (error) {
        console.error("批量移除成分失败", error);
        ElMessage.error("批量移除失败");
      }
    }
    function closeDialog() {
      emit("closeDialog");
    }
    // 监听对话框显示状态
    watch(() => props.dialogVisible, newVal => {
      if (newVal) {
        // 对话框打开时加载数据
        getItemList();
        getSelectedItemList();
        getIngredList();
        getSelectedIngredList();
      } else {
        // 对话框关闭时清空数据
        itemSearchKey.value = "";
        selectedItemSearchKey.value = "";
        ingredSearchKey.value = "";
        selectedIngredSearchKey.value = "";
      }
    });
    // 表格选择项变化处理函数
    function handleItemSelectionChange(val) {
      selectedItems.value = val;
    }
    function handleSelectedItemSelectionChange(val) {
      selectedSelectedItems.value = val;
    }
    function handleIngredSelectionChange(val) {
      selectedIngreds.value = val;
    }
    function handleSelectedIngredSelectionChange(val) {
      selectedSelectedIngreds.value = val;
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "",
        width: "1400px",
        onClose: closeDialog
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("div", {
          class: "item-title"
        }, "选择物品", -1)), _createElementVNode("div", _hoisted_3, " 物品列表 (" + _toDisplayString(selectedItems.value.length) + "/" + _toDisplayString(itemList.value.length) + ") ", 1), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_input, {
          modelValue: itemSearchKey.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => itemSearchKey.value = $event),
          placeholder: "请输入名称",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: searchItems
        }, {
          default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("搜索")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_table, {
          data: itemList.value,
          border: "",
          style: {
            "width": "100%"
          },
          height: "400px",
          onSelectionChange: handleItemSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "物品名称"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "80"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              type: "primary",
              size: "small",
              onClick: $event => addItem(scope.row)
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("添加")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          "pager-count": 5,
          "page-size": itemPage.size,
          onCurrentChange: getItemList,
          total: itemPage.total
        }, null, 8, ["page-size", "total"])]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: batchAddItems
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("批量添加")])),
          _: 1
        })])]), _createElementVNode("div", _hoisted_8, [_cache[11] || (_cache[11] = _createElementVNode("div", {
          class: "item-title"
        }, "已选择物品", -1)), _createElementVNode("div", _hoisted_9, [props.eatType === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "可食用物品")) : _createCommentVNode("", true), props.eatType === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "不可食用物品")) : _createCommentVNode("", true), props.eatType === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "限量食用物品")) : _createCommentVNode("", true), _createTextVNode(" (" + _toDisplayString(selectedSelectedItems.value.length) + "/" + _toDisplayString(selectedItemList.value.length) + ") ", 1)]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_el_input, {
          modelValue: selectedItemSearchKey.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectedItemSearchKey.value = $event),
          placeholder: "请输入名称",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: searchSelectedItems
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [_createTextVNode("搜索")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_14, [_createVNode(_component_el_table, {
          data: selectedItemList.value,
          border: "",
          style: {
            "width": "100%"
          },
          height: "400px",
          onSelectionChange: handleSelectedItemSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "物品名称"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "80"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              type: "danger",
              size: "small",
              onClick: $event => removeItem(scope.row)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode("移除")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          "pager-count": 5,
          "page-size": selectedItemPage.size,
          onCurrentChange: getSelectedItemList,
          total: selectedItemPage.total
        }, null, 8, ["page-size", "total"])]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_button, {
          type: "danger",
          onClick: batchRemoveItems
        }, {
          default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode("批量移除")])),
          _: 1
        })])]), _createElementVNode("div", _hoisted_17, [_cache[15] || (_cache[15] = _createElementVNode("div", {
          class: "item-title"
        }, "选择成分", -1)), _createElementVNode("div", _hoisted_18, " 成分列表 (" + _toDisplayString(selectedIngreds.value.length) + "/" + _toDisplayString(ingredList.value.length) + ") ", 1), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_input, {
          modelValue: ingredSearchKey.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ingredSearchKey.value = $event),
          placeholder: "请输入名称",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: searchIngreds
        }, {
          default: _withCtx(() => _cache[12] || (_cache[12] = [_createTextVNode("搜索")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_table, {
          data: ingredList.value,
          border: "",
          style: {
            "width": "100%"
          },
          height: "400px",
          onSelectionChange: handleIngredSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "成分名称"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "80"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              type: "primary",
              size: "small",
              onClick: $event => addIngred(scope.row)
            }, {
              default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode("添加")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          "pager-count": 5,
          "page-size": ingredPage.size,
          onCurrentChange: getIngredList,
          total: ingredPage.total
        }, null, 8, ["page-size", "total"])]), _createElementVNode("div", _hoisted_22, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: batchAddIngreds
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode("批量添加")])),
          _: 1
        })])]), _createElementVNode("div", _hoisted_23, [_cache[19] || (_cache[19] = _createElementVNode("div", {
          class: "item-title"
        }, "已选择成分", -1)), _createElementVNode("div", _hoisted_24, [props.eatType === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_25, "可食用成分")) : _createCommentVNode("", true), props.eatType === 2 ? (_openBlock(), _createElementBlock("span", _hoisted_26, "不可食用成分")) : _createCommentVNode("", true), props.eatType === 3 ? (_openBlock(), _createElementBlock("span", _hoisted_27, "限量食用成分")) : _createCommentVNode("", true), _createTextVNode(" (" + _toDisplayString(selectedSelectedIngreds.value.length) + "/" + _toDisplayString(selectedIngredList.value.length) + ") ", 1)]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_input, {
          modelValue: selectedIngredSearchKey.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => selectedIngredSearchKey.value = $event),
          placeholder: "请输入名称",
          clearable: ""
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: searchSelectedIngreds
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode("搜索")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_el_table, {
          data: selectedIngredList.value,
          border: "",
          style: {
            "width": "100%"
          },
          height: "400px",
          onSelectionChange: handleSelectedIngredSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "成分名称"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            width: "80"
          }, {
            default: _withCtx(scope => [_createVNode(_component_el_link, {
              type: "danger",
              size: "small",
              onClick: $event => removeIngred(scope.row)
            }, {
              default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("移除")])),
              _: 2
            }, 1032, ["onClick"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_30, [_createVNode(_component_el_pagination, {
          layout: "prev, pager, next",
          "pager-count": 5,
          "page-size": selectedIngredPage.size,
          onCurrentChange: getSelectedIngredList,
          total: selectedIngredPage.total
        }, null, 8, ["page-size", "total"])]), _createElementVNode("div", _hoisted_31, [_createVNode(_component_el_button, {
          type: "danger",
          onClick: batchRemoveIngreds
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("批量移除")])),
          _: 1
        })])])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
});